import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'
import Icons from '@olxbr/olx-icons'
import EmailChip from '../../atoms/EmailChip'
import GenericBox from '../../atoms/GenericBox'
import MailShieldIcon from '../../atoms/MailShieldIcon'

import { truncate } from '../../../util/mask'
import Lurker from '../../../util/lurker'

const lurker = new Lurker('email_confirmation_sent')

const Content = styled(View)`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`

const LabelBoxView = styled(View)`
  margin-top: 8px;
`

const TitleWrapper = styled(View)`
  margin-top: 28px;
`

const Description = styled(Text)`
  text-align: center;
  margin-top: 24px;
  margin-bottom: 8px;
`

const SafetyTip = styled(View)`
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
`

const BoxWrapper = styled(GenericBox)`
  justify-content: center;
  min-height: 52px;
  margin-top: 24px;
  max-width: 305px;
  height: 52px;
  padding: 0;
`

const IconWrapper = styled(View)`
  margin-right: 8px;
  padding: 0;
`

class EmailConfirmationSentTemplate extends React.Component {
  componentDidMount() {
    lurker.pageLoadEvt()
  }

  render = () => {
    const { onEmailClick, email } = this.props
    return (
      <Content>
        <MailShieldIcon />
        <TitleWrapper>
          <Text size="title2" weight="semiBold">
            Verifique seu e-mail
          </Text>
        </TitleWrapper>
        <Description size="body1" weight="regular">
          Você precisa concluir uma etapa rápida antes de criar sua conta. Clique no botão do e-mail
          que enviamos para
        </Description>
        <LabelBoxView>
          <EmailChip href="#" onClick={onEmailClick}>
            {truncate(email)}
          </EmailChip>
        </LabelBoxView>
        <BoxWrapper direction="column">
          <SafetyTip>
            <IconWrapper>
              <Icons.System.Award size="16" color="#999999" />
            </IconWrapper>
            <Text size="body2" color="grayscale.darker">
              Conquistará selo de e-mail verificado.
            </Text>
          </SafetyTip>
        </BoxWrapper>
      </Content>
    )
  }
}

EmailConfirmationSentTemplate.propTypes = {
  email: PropTypes.string.isRequired,
  onEmailClick: PropTypes.func.isRequired,
}

export default EmailConfirmationSentTemplate
